<template>
  <b-container fluid>
    <b-row>
      <b-col class="p-0">
        <b-button
          :class="{
            'btn-block': modalType === 'create',
            'cover-blank-form-btn': modalType === 'create',
            'cover-blank-form-btn-edit': modalType === 'edit',
          }"
          @click="handler"
        >
          {{ modalType === "create" ? "สร้างฟอร์มเปล่า" : "แก้ไข" }}
        </b-button>
      </b-col>
    </b-row>
    <b-modal
      id="blank-form-modal"
      ref="blankFormModal"
      size="xl"
      centered
      :title="modalType === 'create' ? 'สร้างฟอร์มเปล่า' : 'แก้ไขฟอร์มเปล่า'"
      :ok-title="modalType === 'create' ? 'พิมพ์' : 'บันทึก'"
      cancel-title="ยกเลิก"
      @ok="createBlankFormHandler"
    >
      <b-container fluid>
        <b-form ref="blankForm" @submit.stop.prevent="handleSubmit">
          <b-form-group class="text-left">
            <b-form-checkbox
              v-model="hasHeader"
              :unchecked-value="false"
              :value="true"
            >
              แสดงหัวกระดาษ
            </b-form-checkbox>
          </b-form-group>
          <!--          <b-form-group-->
          <!--            id="form-number-group"-->
          <!--            label="เลขที่แบบฟอร์ม:"-->
          <!--            label-for="form-number"-->
          <!--            description="ไม่จำเป็น"-->
          <!--            class="text-left"-->
          <!--            :state="nameState"-->
          <!--          >-->
          <!--            <b-form-input-->
          <!--              id="form-number"-->
          <!--              v-model="formNumber"-->
          <!--              type="text"-->
          <!--              :state="nameState"-->
          <!--              placeholder="กรุณากรอกเลขที่ฟอร์ม"-->
          <!--            />-->
          <!--          </b-form-group>-->
          <b-form-group
            id="title-group"
            label="หัวข้อ:"
            label-for="title"
            description="ไม่จำเป็น."
            class="text-left"
          >
            <b-form-input
              id="title"
              v-model="title"
              type="text"
              placeholder="กรุณากรอกหัวข้อ"
            />
          </b-form-group>
          <!--          <b-form-group-->
          <!--            id="created-date-group"-->
          <!--            label="วันที่ออกแบบฟอร์ม:"-->
          <!--            label-for="created-date"-->
          <!--            description="ไม่จำเป็น"-->
          <!--            class="text-left"-->
          <!--            :state="nameState"-->
          <!--          >-->
          <!--            <datepicker-->
          <!--              v-model="createdDate"-->
          <!--              input-class="date-form-input form-control"-->
          <!--            />-->
          <!--          </b-form-group>-->
          <b-form-group
            id="content-group"
            label="เนื้อหาแบบฟอร์ม:"
            label-for="form-number"
            description="ไม่จำเป็น"
            class="text-left"
          >
            <b-form-textarea
              id="content"
              v-model="content"
              placeholder="กรุณากรอกเนื้อหาแบบฟอร์ม..."
              rows="10"
            />
          </b-form-group>
        </b-form>
      </b-container>
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import printJS from "print-js";

export default {
  name: "BlankDocumentFormModal",
  components: {
    Datepicker,
  },
  props: {
    modalType: {
      type: String,
      default: "create",
    },
    id: {
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      platforms: "Account/getPlatforms",
    }),
    corporationSelected: {
      get() {
        return this.$store.state.Account.corporationId;
      },
      set(val) {
        this.$store.commit("Account/SET_CORPORATION_ID", val);
      },
    },
  },
  mounted() {
    this.createdDate = new Date();
    this.title = null;
    this.content = null;
    this.formNumber = null;
    this.nameState = null;
  },
  data() {
    return {
      title: null,
      content: null,
      nameState: null,
      hasHeader: true,
    };
  },
  methods: {
    ...mapActions({
      createBlankForm: "Account/createBlankForm",
      editBlankForm: "Account/editBlankForm",
      getBlankForm: "Account/getBlankForm",
    }),
    async createBlankFormHandler(bvModalEvt) {
      bvModalEvt.preventDefault();

      await this.handleSubmit();
    },
    async handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }

      // let corporation = this.platforms.find(element => {
      //   return element.id === this.corporationSelected;
      // });

      let payload = {
        corporation_id: this.corporationSelected.id,
        title: this.title,
        content: this.content,
        has_header: this.hasHeader,
      };

      this.$refs.blankFormModal.hide();
      this.$store.state.isLoading = true;

      let res;
      if (this.modalType === "create") {
        if (payload.title || payload.content) {
          const confirm = await this.$swal.fire({
            title: "ท่านต้องการบันทึกแบบฟอร์มด้วยหรือไม่",
            text: "บันทึกแบบฟอร์มเพื่อใช้พิมพ์ในครั้งถัดไป",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "บันทึก",
            cancelButtonText: "ไม่บันทึก",
            showLoaderOnConfirm: true,
          });

          if (confirm.value) {
            payload.isSave = true;
          }
        }

        res = await this.createBlankForm(payload);
      } else {
        res = await this.editBlankForm({ id: this.id, payload });
      }

      if (res) {
        // print form

        if (res.pdf_file) {
          printJS({
            printable: res.pdf_file,
            type: "pdf",
            showModal: true,
            base64: true,
          });
        }

        // Hide the modal manually
        this.$nextTick(() => {
          this.$swal.fire("Success", "บันทึกข้อมูลเสร็จสิ้น", "success");
          this.$refs.blankFormModal.hide();
          this.$store.state.isLoading = false;
        });
      } else {
        this.$swal.fire("Error", "เกิดข้อผิดพลาด", "error");
        this.$refs.blankFormModal.hide();
        this.$store.state.isLoading = false;
      }
    },
    checkFormValidity() {
      const valid = this.$refs.blankForm.checkValidity();
      this.nameState = valid ? "valid" : "invalid";
      return valid;
    },
    async handler() {
      if (this.id) {
        let res = await this.getBlankForm(this.id);
        this.id = res.id;
        this.title = res.title;
        this.content = res.content;
        this.hasHeader = res.has_header;
      } else {
        this.id = null;
        this.title = null;
        this.content = null;
        this.hasHeader = true;
      }

      this.$refs.blankFormModal.show();
    },
  },
  // watch: {
  //   modalType() {
  //     if (this.modalType === 'create') {
  //       this.createdDate = new Date();
  //     } else {
  //       this.createdDate = this.data.createDate
  //       this.title = this.data.title
  //       this.content = this.data.content
  //       this.formNumber = this.data.form_number
  //     }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.cover-blank-form-btn {
  background-color: #009906;
  border: none;
}
.cover-blank-form-btn-edit {
  background-color: #2e83d9;
  border: none;
}
</style>

<style>
.date-form-input {
  background-color: white !important;
}
</style>
